export default __webpack_public_path__ + "assets/models/a0c5791313432d6b2a1266f9416aebfe.glb";